import {
  BarChart3,
  Download,
  Globe2,
  HardDrive,
  ListMusic,
  CircleHelp,
  Radio,
  Users,
} from 'lucide-react'

import { Popover } from '#components/ui/popover.jsx'

const icons = {
  'chart-no-axes-combined': BarChart3,
  'download': Download,
  'globe': Globe2,
  'hard-drive': HardDrive,
  'list-music': ListMusic,
  'radio': Radio,
  'users': Users,
}

function text(feature) {
  if ('enabled' in feature) return feature.enabled ? feature.label : null
  if (feature.limit === null) return `Unlimited ${feature.label.toLowerCase()}`
  const value = feature.limit.toLocaleString()
  return feature.unit
    ? `${value} ${feature.unit} ${feature.label.toLowerCase()}`
    : `${value} ${feature.label.toLowerCase()}`
}

export function QuotaFeatures({ features, className = 'space-y-3 text-sm' }) {
  const visible = features
    .map(feature => ({ ...feature, text: text(feature) }))
    .filter(feature => feature.text)

  if (!visible.length) return null

  return (
    <ul className={className}>
      {visible.map(feature => {
        const Icon = icons[feature.icon] || Radio
        return (
          <li className='flex items-start gap-2' key={feature.key}>
            <Icon
              aria-hidden='true'
              className='mt-0.5 size-4 shrink-0 text-primary'
            />
            <span>{feature.text}</span>
            {feature.description && (
              <Popover
                content={feature.description}
                label={`What does ${feature.label} mean?`}
              >
                <CircleHelp aria-hidden='true' className='size-4' />
              </Popover>
            )}
          </li>
        )
      })}
    </ul>
  )
}
